const ILLUSTRATION_NAME_REGEX = /[^a-z_]/g;

export function allRegionImagesPresent(images) {
    var allRegionImagesPresent = true;
    Object.keys(images).forEach((key) => {
        if (!images[key]) {
            allRegionImagesPresent = false;
        }
    });
    return allRegionImagesPresent;
}

export function validIllustrationName(illustrationName) {
    return illustrationName && !illustrationName.match(ILLUSTRATION_NAME_REGEX);
}

export function getIllustrationNameError(illustrationName) {
    if (!illustrationName) {
        return 'Illustration name cannot be empty';
    }

    if (illustrationName.match(/[A-Z]/g)) {
        return 'Uppercase characters not allowed';
    }

    if (illustrationName.match(/[\d]/g)) {
        return 'Numeric characters not allowed';
    }

    if (illustrationName.match(/[^a-z_]/g)) {
        return 'Special characters except _ not allowed';
    }
}
